// @ts-strict-ignore
import {Component, Input, IterableDiffers} from "@angular/core";
import {EventEmitterService} from "@event-emitter";
import {SimEnumExtendedService, NotificationService, SimDebriefingService, SimAudioChannelService} from "@services";
import {SimSystemExtendedService} from "@services";
import {PlayerMapping} from "@models";
import {TranslateService} from "@ngx-translate/core";
import {AudioChannelControlPanelComponent} from "./audio-channel-control-panel.component";
import Enumerable from "linq";
import {Translations} from "@translations";

@Component({
	selector: "sim-tablet-audio-channel-control-panel",
	templateUrl: "./audio-channel-control-panel.component.html",
	styleUrls: ["./audio-channel-control-panel.component.scss"],
	providers: [EventEmitterService],
	standalone: false,
})
export class TabletAudioChannelControlPanelComponent extends AudioChannelControlPanelComponent {
	T = Translations;
	@Input() playerInfo: PlayerMapping = null;

	constructor(
		protected _emitterService: EventEmitterService,
		protected _simSystemService: SimSystemExtendedService,
		protected _simEnumExtendedService: SimEnumExtendedService,
		protected _simDebriefingService: SimDebriefingService,
		protected _simNotificationService: NotificationService,
		protected _simAudioChannelService: SimAudioChannelService,
		protected translate: TranslateService,
		protected differs: IterableDiffers,
	) {
		super(
			_emitterService,
			_simSystemService,
			_simAudioChannelService,
			_simEnumExtendedService,
			_simDebriefingService,
			_simNotificationService,
			translate,
			differs,
		);
	}

	public toggleSolo(channelId: string, channelGroupId: string) {
		if (channelId) {
			this._simDebriefingService
				.toggleSolo({
					playerId: this.playerInfo.id,
					audioChannelId: channelId,
					audioChannelGroupId: channelGroupId,
					scenarioRecordingId: this.scenarioRecording.id,
					scenarioRecordingSceneId: this.scenarioRecording.recordingScenes[this.scenarioRecordingSceneIndex].recordingSceneId,
				})
				.then((toggleMuteAudioChannelResult) => {
					if (!toggleMuteAudioChannelResult) {
						this._simNotificationService.notifyError(this.translate.instant(this.T.WEB_DEBRIEFING_MUTE_AUDIO_CHANNEL));
					}
				});
		}
	}

	public toggleMute(channelId: string, channelGroupId?: string) {
		if (channelId) {
			this._simDebriefingService
				.toggleMute({
					playerId: this.playerInfo.id,
					audioChannelId: channelId,
				})
				.then((toggleMuteAudioChannelResult) => {
					if (!toggleMuteAudioChannelResult) {
						this._simNotificationService.notifyError(this.translate.instant(this.T.WEB_DEBRIEFING_MUTE_AUDIO_CHANNEL));
					}
				});
		}
	}

	public setVolume(channelId: string, channelGroupId: string, volume: number) {
		if (channelId) {
			this._simDebriefingService
				.setVolume({
					playerId: this.playerInfo.id,
					audioChannelId: channelId,
					audioChannelGroupId: channelGroupId,
					scenarioRecordingId: this.scenarioRecording.id,
					scenarioRecordingSceneId: this.scenarioRecording.recordingScenes[this.scenarioRecordingSceneIndex].recordingSceneId,
					volume: volume,
				})
				.then((setVolumeResult) => {
					if (!setVolumeResult) {
						this._simNotificationService.notifyError(this.translate.instant(this.T.WEB_DEBRIEFING_CHANGE_VOLUME));
					}
				});
		}
	}

	public toggleGroupSolo(channelGroupId: string) {
		if (channelGroupId) {
			this._simDebriefingService
				.toggleGroupSolo({
					playerId: this.playerInfo.id,
					audioChannelGroupId: channelGroupId,
					otherAudioChannelGroupIds: Enumerable.from(this.audioChannelGroups)
						.select((group) => group.id)
						.except([channelGroupId])
						.toArray(),
					scenarioRecordingId: this.scenarioRecording.id,
					scenarioRecordingSceneId: this.scenarioRecording.recordingScenes[this.scenarioRecordingSceneIndex].recordingSceneId,
				})
				.then((setVolumeResult) => {
					if (!setVolumeResult) {
						this._simNotificationService.notifyError(this.translate.instant(this.T.WEB_DEBRIEFING_CHANGE_VOLUME));
					}
				});
		}
	}

	public toggleGroupMute(channelGroupId: string) {
		if (channelGroupId) {
			this._simDebriefingService
				.toggleGroupMute({
					playerId: this.playerInfo.id,
					audioChannelGroupId: channelGroupId,
					scenarioRecordingId: this.scenarioRecording.id,
					scenarioRecordingSceneId: this.scenarioRecording.recordingScenes[this.scenarioRecordingSceneIndex].recordingSceneId,
				})
				.then((setVolumeResult) => {
					if (!setVolumeResult) {
						this._simNotificationService.notifyError(this.translate.instant(this.T.WEB_DEBRIEFING_CHANGE_VOLUME));
					}
				});
		}
	}

	public setGroupVolume(channelGroupId: string, volume: number) {
		if (channelGroupId) {
			this._simDebriefingService
				.setGroupVolume({
					playerId: this.playerInfo.id,
					audioChannelGroupId: channelGroupId,
					scenarioRecordingId: this.scenarioRecording.id,
					scenarioRecordingSceneId: this.scenarioRecording.recordingScenes[this.scenarioRecordingSceneIndex].recordingSceneId,
					volume: volume,
				})
				.then((setVolumeResult) => {
					if (!setVolumeResult) {
						this._simNotificationService.notifyError(this.translate.instant(this.T.WEB_DEBRIEFING_CHANGE_VOLUME));
					}
				});
		}
	}
}
